(function ( $, _ ) {
	$( function () {
		window.history.scrollRestoration = 'manual';
		if (ACTUAL_CATEGORY != 0) {

			$(document).on('click', '[data-zg-role="product-link"]', function(event) {		
				var position = $(window).scrollTop();
				$('.loading-overlay').remove();
				var category_id = ACTUAL_CATEGORY;
				zgCreateCookie('last_position', position, 1);
				zgCreateCookie('last_category_id', category_id, 1);
				can_erased=false;
				console.log(position);
				console.log(category_id);
			
			});

			var last_position = zgReadCookie('last_position');
			var last_category_id = zgReadCookie('last_category_id');
			var flagOn= true;
			if ( last_position && last_category_id && last_category_id == ACTUAL_CATEGORY ) {

				$('.loading-overlay').show();
				$(window).on('zg.pagination.pageRendered', function() {
					if(flagOn){
						flagOn= false;
						setTimeout(function(){  
							$("html, body").animate({ scrollTop: last_position }, 100, 'swing', function() {
								var position = $(window).scrollTop();
								//console.log(position);
								//console.log(last_position);
								if (position >= last_position-50) {
									$('.loading-overlay').hide();
									$('.loading-overlay').remove();
									//console.log('ERASE');
									
									zgEraseCookie('last_position');
									zgEraseCookie('last_category_id');
								}
							});
						}, 1000);
					}
				});	

			}


		}else{
			zgEraseCookie('last_position');
			zgEraseCookie('last_category_id');
		}	
	} );
}( jQuery, _ ));	



/*
var can_erased=true;



//Return to category at same place
$(window).on('zg.pagination.pageRendered', function() {

	//heightContainer(); //set height of .product-preview .images-container
	
	

	if (ACTUAL_CATEGORY != 0) {
		var last_position = zgReadCookie('last_position');
		var last_category_id = zgReadCookie('last_category_id');

		
		//console.log('aaa');
		//console.log(last_position);

		//n_prod++;

		
		if ( last_position && last_category_id && last_category_id == ACTUAL_CATEGORY ) {

			if ( $('body').hasClass('page_category') ) {				
				
				$('.loading-overlay').show();


				to = last_position;

				console.log(to);
				console.log(last_position);

				setTimeout(function(){  
				$("html, body").animate({ scrollTop: to }, 100, 'swing', function() {
					var position = $(window).scrollTop();
					//console.log(position);
					//console.log(last_position);
					if (position >= last_position-50) {
						$('.loading-overlay').hide();
						$('.loading-overlay').remove();
						//console.log('ERASE');
						if(can_erased){
							
							zgEraseCookie('last_position');
							zgEraseCookie('last_category_id');
						}
					}
				});
				}, 3000);

			} else if ( !$('body').hasClass('page_product') ) {
				//console.log('ERASE');
				
				if(can_erased){
					zgEraseCookie('last_position');
					zgEraseCookie('last_category_id');
				}
			}
		}
		
		
	} else {
		//console.log('ERASE');
		zgEraseCookie('last_position');
		zgEraseCookie('last_category_id');
	}		
});
*/
